module.exports = __webpack_public_path__ + "static/media/function_hk.1ee48edb.png";